import Modal from 'react-modal';

interface Props {
  isOpen: boolean;
  presentation: string;
  onRequestClose: () => void;
}
export default function ModalViewPresentation({ isOpen, onRequestClose, presentation }: Props) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-view-presentation-modal-content">
      <h1>Carta de apresentação</h1>
      <div className="content">
        <p>{presentation}</p>
      </div>
    </Modal>
  );
}
